module.exports = __webpack_public_path__ + "fonts/Gilroy-ExtraBold.cc2923a0.otf";